<template>
  <section class="section">
    <div class="colums">
      <div class="column is-paddingless">
        <h1 class="title">Overview</h1>
      </div>
    </div>

    <div class="columns is-multiline">
      <statistics-text />

      <div class="column is-6">
        <distance-chart />
      </div>

      <div class="column is-6">
        <fuel-consumption-chart />
      </div>

      <div class="column is-6">
        <expenses-and-average-expenses-chart />
      </div>
    </div>
  </section>
</template>

<script>
import StatisticsText from '../components/statistics/StatisticsText.vue';


import ExpensesAndAverageExpensesChart
  from '../components/statistics/ExpensesAndAverageExpensesChart.vue';
import DistanceChart from '../components/statistics/DistanceChart.vue';
import FuelConsumptionChart from '../components/statistics/FuelConsumptionChart.vue';

export default {
  name: 'Statistics',
  components: {
    FuelConsumptionChart,
    DistanceChart,
    StatisticsText,
    ExpensesAndAverageExpensesChart,
  },
};
</script>

<style scoped>

</style>
